import { h } from "preact";

import i18n from "../../i18n.js";

import InfoLine from "../InfoLine.jsx";
import SkillChooser from "../questions/SkillChooser.jsx";
import Slider from "../Slider.jsx";

export default function ProjectWizardStep2({
  config,
  editMode,
  form,
  formErrors,
  formStep1,
}) {
  const { fieldsFor, setFormDataValue } = form;
  const areaOfWork = formStep1.fieldsFor("areaOfWork").value;

  const seniorityFieldOptions = fieldsFor("seniority", {
    serverErrors: formErrors.seniority,
  });
  seniorityFieldOptions.onChange = seniorityFieldOptions.onInput;

  const skillsFieldOptions = fieldsFor("skills", {
    serverErrors: formErrors.skills,
  });
  skillsFieldOptions.answer = skillsFieldOptions.value;

  return (
    <div>
      <div class="row">
        <div class="col s12 m10 l8 mb-32">
          {!editMode && (
            <h1 class="t-h5 t-h5--margin">
              {i18n.t("component.projects_add.projects_wizard.step2.title")}
            </h1>
          )}
          {!editMode && (
            <p class="t-body3 color-shades-charcoal mb-32">
              {i18n.t("component.projects_add.projects_wizard.step2.subtitle")}
            </p>
          )}

          <h3 class="t-subtitle1 t-subtitle1--margin-small">
            {i18n.t(
              "component.projects_add.projects_wizard.step2.seniority.title"
            )}
          </h3>
          <p class="t-body3 color-shades-charcoal mb-32">
            {i18n.t(
              "component.projects_add.projects_wizard.step2.seniority.subtitle"
            )}
          </p>
          <Slider
            {...seniorityFieldOptions}
            possibleValues={config.seniorityLevels.reduce(
              (mem, [text, key]) => {
                mem[key] = text;
                return mem;
              },
              {}
            )}
          />

          <InfoLine
            text={i18n.t(
              `component.projects_add.projects_wizard.step2.seniority.level.${seniorityFieldOptions.value}`
            )}
          />
        </div>

        <div class="col s12 m10 l8 mb-32">
          <h3 class="t-subtitle1 t-subtitle1--margin-small">
            {i18n.t(
              "component.projects_add.projects_wizard.step2.skills.title"
            )}
          </h3>
          <p class="t-body3 color-shades-charcoal mb-32">
            {i18n.t(
              "component.projects_add.projects_wizard.step2.skills.subtitle"
            )}
          </p>

          <SkillChooser
            {...skillsFieldOptions}
            key={areaOfWork}
            onSelect={(value) => setFormDataValue("skills", value)}
            options={{
              likert: config.skillProficiencies.length,
              choices: config.skills[areaOfWork],
              proficiencies: config.skillProficiencies,
              label: i18n.t(
                "component.projects_add.projects_wizard.step2.skills.label"
              ),
              valueI18nPrefix:
                "component.projects_add.projects_wizard.step2.skills.values.",
            }}
          />
        </div>
      </div>
    </div>
  );
}
